import { Card } from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_4 } from 'constants/theme-constants';
import styled from 'styled-components';

export const SummaryCardMainText = styled.div`
  ${({ theme }) => `
    ${theme.display[4].demi};
`}
`;

export const CardStyled = styled(Card)`
  height: 128px;
  flex: 1 1 276px;
`;

export const SuffixPrefix = styled.div`
  ${({ theme }) => theme.label.extraLarge.demi}
`;

export const CardExpandableContentContainer = styled.div`
  ${({ theme }) => `
    position: absolute;
    transition: all 0.3s ease-in-out;
    width: 100%;
    overflow: hidden;
    z-index: 1;
    top: 95%;
    background-color: ${theme.onSurface.surface.default.background};
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: ${cxTheme.borderRadius.primaryRadius};
    border-bottom-left-radius: ${cxTheme.borderRadius.primaryRadius};
    box-shadow: 0px 6px 8px rgb(0 32 92 / 15%);
`}
`;

export const SummaryCardWrapper = styled.div`
  ${({ theme }) => `
    padding-top: ${cxTheme.spacing[SPACING_4]};
`}
`;
